import React, { Component } from "react";
import { Nav, NavItem, MenuItem, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import _ from "underscore";
import LoaderPanel from "../components/LoaderPanel";
import ConfirmDropdown from "../components/ConfirmDropdown";
import TitlePage from "../components/TitlePage";
import MenuNavbar from "../components/MenuNavbar";
import LoaderButton from "../components/LoaderButton";
import { EDTabs, EDTableSection, EDTable, EDTableRow, EDCardsContainer, EDCard } from "../components/EDDOM";
import moment from "moment";
import notify from "../utils/notify";
import TablePie from "../components/TablePie";
import SearchControl from "../components/SearchControl";
import parse from "../utils/parse";
import qs from "qs";

import "./Broadcasts.css";
/* eslint import/no-webpack-loader-syntax: off */
import WarningIcon from '-!svg-react-loader!../svg/warning.svg';
import MessageIcon from '-!svg-react-loader!../svg/menu-icons/frontend-navigation-messages.svg';

class AlertTD extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlert: false,
    }
  }

  highBounces(c) {
    var rate = 2.0;
    if (this.props.user && this.props.user.frontend)
      rate = this.props.user.frontend.bouncerate;
    return this.pctnum(c, c.bounced, 'delivered') >= rate ||
           this.pctnum(c, c.soft, 'delivered') >= rate;
  }

  highComplaints(c) {
    var rate = 2.0;
    if (this.props.user && this.props.user.frontend)
      rate = this.props.user.frontend.complaintrate;
    return this.pctnum(c, c.complained, 'send') >= rate;
  }

  needsAlert(c) {
    return c.overdomaincomplaint || c.overdomainbounce || this.highComplaints(c) || this.highBounces(c) || c.error;
  }

  pctnum(l, n, prop) {
    if (!prop)
      prop = 'count'
    if (!l[prop] || !_.isNumber(l[prop]) || !n)
      return 0.0;
    return (n/l[prop])*100;
  }

  toggleAlert = () => {
    if (this.needsAlert(this.props.c)) {
      this.setState({showAlert: !this.state.showAlert});
    }
  }

  ignore = event => {
    event.preventDefault();
  }

  render() {
    var c = this.props.c;

    return (
      <td onClick={this.toggleAlert} style={{position: 'relative', cursor:this.needsAlert(c)?'pointer':undefined}} className={this.state.showAlert?'error-menu':''}>
        {this.needsAlert(c) && <WarningIcon className="warning-icon"/>}
        <ul className="list-unstyled alert-popup" style={{zIndex: 9999, opacity: 1, display: this.state.showAlert?'block':'none'}}>
          <li style={{display: this.highBounces(c)?undefined:'none'}}>
            <a href="#t" onClick={this.ignore}>
              <span></span>
              High Bounces!
            </a>
          </li>
          <li style={{display: this.highComplaints(c)?undefined:'none'}}>
            <a href="#t" onClick={this.ignore}>
              <span></span>
              High Complaints!
            </a>
          </li>
          <li style={{display: c.overdomaincomplaint?undefined:'none'}}>
            <a href="#t" onClick={this.ignore}>
              <span></span>
              High Domain Complaints!
            </a>
          </li>
          <li style={{display: c.overdomainbounce?undefined:'none'}}>
            <a href="#t" onClick={this.ignore}>
              <span></span>
              High Domain Bounces!
            </a>
          </li>
          <li style={{display: c.error?undefined:'none'}}>
            <div className="text-danger">{c.error}</div>
          </li>
        </ul>
      </td>
    );
  }
}

export default class Broadcasts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: '1',
      isLoading: false,
      loadingOlder: false,
      data: [],
      count: 0,
      hasnewer: false,
      hasolder: false,
      search: '',
      lastParams: '',
    }
  }

  componentWillMount() {
    this.reload(false, true, undefined, parse(this))
  }

  getList(tab) {
    if (tab === '1') {
      return _.filter(this.state.data, c => c.sent_at);
    } else if (tab === '2') {
      return _.sortBy(_.filter(this.state.data, c => !c.sent_at && c.scheduled_for), c => c.scheduled_for);
    } else {
      return _.filter(this.state.data, c => !c.sent_at && !c.scheduled_for);
    }
  }

  countText(tab) {
    if (!this.state.data || !this.state.data.length)
      return '';
    var cnt;
    if (tab === '1') {
      cnt = this.state.count;
    } else {
      cnt = this.getList(tab).length;
    }
    if (!cnt)
      return '';
    return ' (' + cnt + ')';
  }

  tabName(tab) {
    if (tab === '1') {
      return 'Sent';
    } else if (tab === '2') {
      return 'Scheduled';
    } else {
      return 'Draft';
    }
  }

  viewOlder = async () => {
    this.setState({loadingOlder: true});
    try {
      var completed = _.filter(this.state.data, c => c.sent_at);
      var params = qs.stringify({older: completed[completed.length-1].sent_at, search: this.state.search});
      var data = (await axios.get('/api/broadcasts?' + params)).data;

      data.campaigns = data.broadcasts;

      this.setState({data: _.filter(this.state.data, c => !c.sent_at).concat(data.campaigns), hasnewer: true, hasolder: data.count > 10,
                     lastParams: params});
    } finally {
      this.setState({loadingOlder: false});
    }
  }

  viewNewer = async () => {
    this.setState({loadingOlder: true});
    try {
      var completed = _.filter(this.state.data, c => c.sent_at);
      var params = qs.stringify({newer: completed[0].sent_at, search: this.state.search});
      var data = (await axios.get('/api/broadcasts?' + params)).data;

      data.campaigns = data.broadcasts;

      this.setState({data: _.filter(this.state.data, c => !c.sent_at).concat(data.campaigns), hasolder: true, hasnewer: data.count > 10,
                     lastParams: params});
    } finally {
      this.setState({loadingOlder: false});
    }
  }

  searchChanged = s => {
    this.setState({search: s}, () => {
      this.reload();
    })
  }

  reload = async (hideLoading, changeTab, tabnum, initialParams) => {
    if (initialParams && initialParams.search) {
      this.setState({isLoading: !hideLoading, search: initialParams.search});
    } else {
      this.setState({isLoading: !hideLoading});
    }

    try {
      var params;
      var hasNewer = false;
      var hasOlder = false;
      if (initialParams) {
        params = 'search=' + encodeURIComponent(initialParams.search || '');
        if (initialParams.older) {
          params += '&older=' + initialParams.older;
          hasNewer = true;
        } else if (initialParams.newer) {
          params += '&newer=' + initialParams.newer;
          hasOlder = true;
        }
      } else {
        params = 'search=' + encodeURIComponent(this.state.search);
      }
      var data = (await axios.get('/api/broadcasts?' + params)).data;

      data.campaigns = data.broadcasts;

      this.setState({data: data.campaigns, count: data.count, hasnewer: hasNewer || (hasOlder && data.count > 10), hasolder: hasOlder || data.count > 10, lastParams: params}, () => {
        if (changeTab) {
          if (tabnum) {
            this.setState({activeTab: tabnum, isLoading: false});
          } else {
            if (this.getList('1').length)
              this.setState({activeTab: '1', isLoading: false});
            else if (this.getList('2').length)
              this.setState({activeTab: '2', isLoading: false});
            else
              this.setState({activeTab: '3', isLoading: false});
          }
        } else if (!hideLoading) {
          this.setState({isLoading: false});
        }
      });
    } catch (e) {
      this.setState({isLoading: false});
    }
  }

  switchView = tab => {
    if (tab === '1' && (this.state.lastParams.includes('older=') || this.state.lastParams.includes('newer='))) {
      this.reload(false, true, tab);
    } else {
      this.setState({activeTab: tab});
    }
  }

  createClicked = async () => {
    this.props.history.push("/broadcasts/settings?id=new");
  }

  cancelConfirmClicked = async id => {
    await axios.post('/api/broadcasts/' + id + '/cancel');
    notify.show('Cancel request sent', 'success');
  }

  deleteConfirmClicked = async id => {
    await axios.delete('/api/broadcasts/' + id);
    await this.reload();
  }

  duplicateClicked = async id => {
    await axios.post('/api/broadcasts/' + id + '/duplicate');

    var data = (await axios.get('/api/broadcasts')).data;

    let broadcasts = _.filter(this.state.data, c => c.sent_at || c.scheduled_for).concat(data.broadcasts.filter(c => !c.sent_at && !c.scheduled_for));

    this.setState({data: broadcasts});
  }

  updateClicked = id => {
    this.props.history.push('/broadcasts/update?id=' + id + '&' + this.state.lastParams);
  }

  exportClicked = async id => {
    await axios.post('/api/broadcasts/' + id + '/export');

    notify.show('Export process started', "success");
  }

  viewClicked = id => {
    this.props.history.push('/broadcasts/summary?id=' + id + '&' + this.state.lastParams);
  }

  componentDidMount() {
    this._interval = setInterval(() => {
      if (!this.state.loadingOlder && !this.state.hasnewer) {
        this.reload(true);
      }
    }, 20000);
  }

  componentWillUnmount() {
    clearInterval(this._interval);
  }

  num(n) {
    if (!n) n = 0;
    return n.toLocaleString();
  }

  pct(l, n, prop) {
    if (!prop)
      prop = 'count'
    if (!l[prop] || !_.isNumber(l[prop]) || !n)
      return '0.0%'
    var v = (n/l[prop])*100;
    var r = Math.round(v)
    if (r < 10) {
      return v.toFixed(1) + '%';
    } else {
      return r + '%';
    }
  }

  campCountText(c) {
    if (!c.sent_at)
      return '';
    if (_.isNumber(c.count))
      return c.count.toLocaleString() + ' recipients';
    return "initializing";
  }

  campPct(c, prop) {
    if (!_.isNumber(c.count) || c.count === 0)
      return 0.0;
    return (c[prop] / c.count) * 100;
  }

  render() {
    const at = this.state.activeTab;
    let minWidth = '600px';
    const maxWidth = '1024px';

    return (
      <div className="broadcasts">
        <MenuNavbar {...this.props}>
        <TitlePage title="Broadcasts" button={
            <LoaderButton
              bsStyle="primary"
              text="Create Broadcast"
              loadingText="Creating..."
              onClick={this.createClicked}
            />
          } tabs={
            <EDTabs>
              <Nav className="nav-tabs space15" activeKey={at}>
                {
                  _.map(['1', '2', '3'], t => {
                    return <NavItem eventKey={t} key={t} onClick={this.switchView.bind(this, t)} className={'tab-' + t}>{this.tabName(t) + this.countText(t)}</NavItem>
                  })
                }
              </Nav>
            </EDTabs>
          } />
          <EDTableSection>
          {
            at === '1' &&
            <div style={{marginLeft: '4%', marginRight: 'auto', maxWidth}}>
              <div className="pull-right" style={{paddingTop: '8px', paddingBottom: '8px'}}>
                <SearchControl onChange={this.searchChanged} value={this.state.search} />
              </div>
            </div>
          }
            <LoaderPanel isLoading={this.state.isLoading}>
            {['1', '2'].indexOf(at) >= 0 &&
              (this.getList(at).length ?
                <EDTable className="growing-margin-left" nospace={at === '1'} minWidth={minWidth} maxWidth={maxWidth}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>
                        { at === '1' ?
                          'Opened'
                          :
                          'Scheduled For'
                        }
                      </th>
                      {
                        at === '1' ?
                        <th>CTR</th>
                        :
                        <th></th>
                      }
                      {
                        at === '1' ?
                        <th>Unsubscribed</th>
                        :
                        <th></th>
                      }
                      {
                        at === '1' ?
                        <th>Complaints</th>
                        :
                        <th></th>
                      }
                      {
                        at === '1' ?
                        <th>Status</th>
                        :
                        <th></th>
                      }
                      <th></th>
                    </tr>
                  </thead>
                  {
                    _.map(this.getList(at), (c, index) => {
                      const finished = c.finished_at || c.canceled || c.error;
                      return (
                      <EDTableRow key={c.id} index={index}>
                        <td>
                          <ul className="list-inline">
                            <li style={{width: '170px'}}>
                              <h4>
                                <Link to={
                                  c.sent_at ?
                                  '/broadcasts/summary?id=' + c.id + '&' + this.state.lastParams
                                  :
                                  '/broadcasts/review?id=' + c.id
                                }>
                                  {c.name}
                                </Link>
                              </h4>
                              <p>
                              {this.campCountText(c)}
                              {
                                c.sent_at &&
                                  <br/>
                              }
                              {
                                c.sent_at &&
                                  <span>started {moment(c.sent_at).format("l LT")}</span>
                              }
                              </p>
                            </li>
                          </ul>
                        </td>
                        {
                          at === '1' ?
                          <td>
                            <h5>{this.pct(c, c.opened, 'send')}</h5>
                            <p>{this.num(c.opened)}</p>
                          </td>
                          :
                          <td>
                            <p>
                              {moment(c.scheduled_for).format('lll')}
                            </p>
                          </td>
                        }
                        {
                          at === '1' ?
                          <td>
                            <h5>{this.pct(c, c.clicked, 'opened')}</h5>
                            <p>{this.num(c.clicked)}</p>
                          </td>
                          :
                          <td></td>
                        }
                        {
                          at === '1' ?
                          <td>
                            <h5 style={{color:'#f46767'}}>{this.pct(c, c.unsubscribed, 'send')}</h5>
                            <p>{this.num(c.unsubscribed)}</p>
                          </td>
                          :
                          <td></td>
                        }
                        {
                          at === '1' ?
                          <td>
                            <h5 style={{color:'#f46767'}}>{this.pct(c, c.complained, 'send')}</h5>
                            <p>{this.num(c.complained)}</p>
                          </td>
                          :
                          <td></td>
                        }
                        {
                          at === '1' && c.sent_at &&
                          <td className="delivered-graph">
                            <TablePie
                              value={this.campPct(c, 'send')}
                              color="#2dcca1"
                              label="COMPLETE"
                              size={65}
                              thickness={7}
                              otherColors={['#4b7efe', '#ffc300']}
                              otherValues={[this.campPct(c, 'hard'), this.campPct(c, 'soft')]}
                            />
                          </td>
                        }
                        {
                          at === '1' && <AlertTD c={c} user={this.props.user} />
                        }
                        <td className="last-cell" style={{minWidth:'138px'}}>
                        { !c.sent_at ?
                          <ConfirmDropdown
                            id={c.id + '-split'}
                            text="Actions"
                            menu="Delete"
                            title="Delete Broadcast Confirmation"
                            prompt={"Are you sure you wish to delete '" + c.name + "'? This action is permanent."}
                            onConfirm={this.deleteConfirmClicked.bind(this, c.id)}>
                            <MenuItem onClick={() => this.props.history.push('/broadcasts/review?id=' + c.id)}>Edit</MenuItem>
                            <MenuItem onClick={this.duplicateClicked.bind(this, c.id)}>Duplicate</MenuItem>
                          </ConfirmDropdown>
                        :
                          <ConfirmDropdown
                            id={c.id + '-split'}
                            text="Actions"
                            menu={!finished ? "Cancel" : "Delete"}
                            title={!finished ? "Cancel Confirmation" : "Delete Confirmation"}
                            prompt={!finished ? "Are you sure you wish to cancel '" + c.name + "'?" : "Are you sure you wish to delete '" + c.name + "'?"}
                            onConfirm={!finished ? this.cancelConfirmClicked.bind(this, c.id) : this.deleteConfirmClicked.bind(this, c.id)}>
                            <MenuItem onClick={this.viewClicked.bind(this, c.id)}>View Report</MenuItem>
                            <MenuItem onClick={this.duplicateClicked.bind(this, c.id)}>Duplicate</MenuItem>
                            {
                            this.props.user && !this.props.user.nodataexport &&
                            <MenuItem onClick={this.exportClicked.bind(this, c.id)}>Export</MenuItem>
                            }
                            <MenuItem onClick={this.updateClicked.bind(this, c.id)}>Update</MenuItem>
                          </ConfirmDropdown>
                        }
                        </td>
                      </EDTableRow>
                      );
                    }
                    )
                  }
                </EDTable>
                :
                <div className="text-center space-top-sm">
                  {
                    (['1', '2'].indexOf(at) >= 0 && this.state.search) ?
                      <h4>No Broadcasts Found</h4>
                    :
                      <h4>No {this.tabName(at)} Broadcasts</h4>
                  }
                </div>)
            }
            {at === '3' &&
              (
              this.getList(at).length ?
              <EDCardsContainer>
                {_.map(this.getList(at), (c, index) => (
                  <EDCard key={c.id} header={
                    <div>
                      <span className="pre-title">DRAFT</span>
                      <h3 className="draft-name">
                        <Link to={'/broadcasts/settings?id=' + c.id}>
                          {c.name}
                        </Link>
                      </h3>
                    </div>
                  }>
                    <Row>
                      <Col xs={12} className="text-center">
                        <MessageIcon  className="message-icon"/>
                      </Col>
                      <Col xs={12} className="text-center">
                        <p className="last-modified">{moment(c.modified).format('lll')}</p>
                      </Col>
                      <Col xs={12} className="text-center space25">
                        <ConfirmDropdown
                          id={c.id + '-split'}
                          text="Actions"
                          menu="Delete"
                          title="Delete Broadcast Confirmation"
                          prompt={"Are you sure you wish to delete '" + c.name + "'? This action is permanent."}
                          onConfirm={this.deleteConfirmClicked.bind(this, c.id)}>
                          <MenuItem onClick={() => this.props.history.push('/broadcasts/settings?id=' + c.id)}>Edit</MenuItem>
                          <MenuItem onClick={this.duplicateClicked.bind(this, c.id)}>Duplicate</MenuItem>
                        </ConfirmDropdown>
                      </Col>
                    </Row>
                  </EDCard>
                ))}
              </EDCardsContainer>
              :
              <div className="text-center space-top-sm">
                <h4>No Drafts Found</h4>
              </div>
              )
            }
            {
              (at === '1' && this.getList('1').length > 0) &&
              <div className="text-right" style={{position: 'relative', marginLeft: '4%', marginRight: 'auto', marginBottom: '30px', maxWidth}}>
                <Button onClick={this.viewNewer} disabled={this.state.loadingOlder || !this.state.hasnewer} style={{
                  display: !this.state.hasnewer ? 'none' : undefined}}>
                  View Newer
                </Button>
                <Button onClick={this.viewOlder} disabled={this.state.loadingOlder || !this.state.hasolder} style={{
                  marginLeft: '10px',
                  display: !this.state.hasolder ? 'none' : undefined}}>
                  View Older
                </Button>
              </div>
            }
            </LoaderPanel>
          </EDTableSection>
        </MenuNavbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Broadcasts.js